import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../component/common/Header";
import Footer from "../../component/common/Footer";

// Importing sections
import HeroSection from "./HeroSection";
import WhyChooseUsSection from "./WhyChooseUsSection";
import ProductRangeSection from "./ProductRangeSection";
import BenefitsSection from "./BenefitsSection";
import CTASection from "./CTASection";
import HowItWorks from "./HowItWorks";

const Sustainability = () => {
  return (
    <>
      <Helmet>
        <title>
          Organic Fertilizers for Sustainable Agriculture | Govardhannathji
          Energies LLP
        </title>
        <meta
          name="description"
          content="Leading provider of organic fertilizers, compost-based fertilizers, vermicompost & bio-enriched manures. Enhance soil health with sustainable farming practices in Gujarat, India."
        />
        <meta
          property="og:title"
          content="Organic Fertilizers for Sustainable Agriculture | Govardhannathji Energies LLP"
        />
        <meta
          property="og:description"
          content="Leading provider of organic fertilizers, compost-based fertilizers, vermicompost & bio-enriched manures. Enhance soil health with sustainable farming practices in Gujarat, India."
        />
      </Helmet>

      <main className="w-full bg-white">
        <Header />

        <section className="w-full">
          <div className="flex flex-col gap-[66px] sm:gap-[99px] lg:gap-[132px] justify-start items-center w-full">
            {/* Main Content Container */}
            <div className="flex flex-col gap-[42px] sm:gap-[63px] lg:gap-[84px] justify-start items-center w-full font-[Sora]">
              <HeroSection />
              <HowItWorks />
              <WhyChooseUsSection />

              <ProductRangeSection />

              <BenefitsSection />

              <CTASection />
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
};

export default Sustainability;
